import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { resultTestimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-paper-card py-20 md:py-28" aria-labelledby="resultados-title" data-id="element-158" data-mp="3kqw1mcxm2ocf">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-159" data-mp="3fy2whny8ddzt">
        <h2 id="resultados-title" className="max-w-xl text-4xl font-extrabold tracking-tightest text-ink md:text-5xl" data-id="element-160" data-mp="3b144bay4nh49">
          Lo que cambió en sus consultorios
        </h2>

        <div className="mt-12 grid gap-x-10 gap-y-10 md:grid-cols-3" data-id="element-161" data-mp="31zmrq2jxhxkb">
          {resultTestimonials.map(t => <figure key={t.name} className="flex h-full flex-col border-t-2 border-accent pt-6" data-id="element-162" data-mp="2x1kywpwpajvn">
              <QuoteIcon className="h-5 w-5 fill-accent text-accent" aria-hidden="true" data-id="element-163" data-mp="2s309llizlklz" />
              <blockquote className="mt-4 text-lg leading-relaxed text-ink" data-id="element-164" data-mp="v7c6l6gih5pe">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-6 text-xs font-bold uppercase tracking-[0.14em] text-ink-muted" data-id="element-165" data-mp="h5f19rwoi73u">
                {t.name} — {t.city}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}